<template>
  <v-select
    :clearable="true"
    :items="dispItems"
    :value="value"
    ref="ctrl"
    v-bind="$attrs"
    v-on="$listeners"
  ></v-select>
</template>
<script>
export default {
  props: ['url', 'value', 'filter', 'init'],
  data() {
    return {
      items: []
    }
  },
  mounted() {
    this.load()
  },
  computed: {
    dispItems() {
      if (this.filter) {
        return this.items.filter(this.filter)
      } else {
        return this.items
      }
    }
  },
  methods: {
    load() {
      this.$http.get(this.url).then(res => {
        this.items = res.data
        if (this.init) {
          let result = this.dispItems.find(this.init)
          if (!result) return
          this.$emit(
            'input',
            this.$refs.ctrl.returnObject
              ? result
              : result[this.$refs.ctrl.itemValue]
          )
        }
      })
    }
  }
}
</script>

